import { observeElement } from '@uvocore-front/utils';
import TestimonialsSlider from './TestimonialsSlider';

const template = i => `<div class="glide__slide">
  <div class="testimonials__item">
    <div class="testimonials__item__header">Type of paper: ${i.orderDiscipline}</div>
    <div class="testimonials__item__body">${i.body}</div>
    <div class="testimonials__item__footer">
      ${i.orderPages > 0 ? `<span>Pages: ${i.orderPages}</span>` : ''}
    </div>
  </div>
</div>`;

observeElement({
  element: '.section-testimonials',
  marginValue: 800,
  callback: () => {
    fetch('/assets/testimonials/list.json?siteId=51&limit=10')
      .then(response => response.json())
      .then(responseData => {
        const { testimonials } = responseData.data;

        document.querySelector('.testimonials').removeChild(document.querySelector('.Loader'));
        const tmNodes = testimonials.map(tm => template(tm)).join('');
        document
          .querySelector('[data-testimonials-widget-js]')
          .insertAdjacentHTML('afterbegin', tmNodes);
        testimonials.forEach((tm, key) => {
          const bullet = document.createElement('button');
          bullet.classList.add('glide__bullet');
          bullet.setAttribute('data-glide-dir', `=${key}`);
          document.querySelector('.glide__bullets').appendChild(bullet);
        });
        TestimonialsSlider();
      });
  },
});
